import React from 'react';
import { collectionLogos } from '../mock';

export default function CollectionLogos() {
  const items = [...collectionLogos, ...collectionLogos, ...collectionLogos];
  return (
    <section className="w-full bg-[#f6f1ea] py-8 overflow-hidden border-y border-neutral-200">
      <div className="marquee-track flex items-center gap-16 whitespace-nowrap" style={{ width: 'max-content' }}>
        {items.map((label, i) => (
          <div key={i} className="flex items-center gap-4">
            <span className="diamond" style={{ width: '14px', height: '14px' }} />
            <span className="serif text-3xl md:text-4xl tracking-[0.15em] text-[#7a1a2a]">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
